import { services } from "../../../../api";
import { hideLoading } from "../../../../connected-components/loader/reducer";
import { showLoading } from "../../../../connected-components/loader/reducer";
import { store } from "../../../../redux/store";

export const fetchMedications = async (patientId: number) => {
  try {
    const response = await services.medications.getMedicationsByPatient(patientId);
    return response;
  } catch (error) {
    console.error('Error fetching medications:', error);
    return null;
  }
};

export const deleteMedication = async (id: number) => {
  try {
    store.dispatch(showLoading());
    const response = await services.medications.deleteMedication(id);
    return response;
  } catch (error) {
    console.error('Error deleting medication:', error);
    return null;
  } finally {
    store.dispatch(hideLoading());
  }
}; 